/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Hasaccount1Inputs */

const zh_auth_hasaccount1 = /** @type {(inputs: Auth_Hasaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账户？`)
};

const en_auth_hasaccount1 = /** @type {(inputs: Auth_Hasaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const es_auth_hasaccount1 = /** @type {(inputs: Auth_Hasaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Hasaccount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_hasaccount1 = /** @type {((inputs?: Auth_Hasaccount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Hasaccount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_hasaccount1(inputs)
	if (locale === "en") return en_auth_hasaccount1(inputs)
	return es_auth_hasaccount1(inputs)
});
export { auth_hasaccount1 as "auth_hasAccount" }